// src/components/Projects/ProjectSingleKA171.jsx
import React from "react";
import { useTranslation } from "react-i18next";

import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import projects from "./projectsData";

function ProjectSingleKA171() {
  const { t } = useTranslation("projectsTranslation");

  const project = projects.find((p) => p.i18nKey === "ka171");
  const baseKey = "projects.ka171";

  // Safe helpers for returnObjects
  const regions = t(`${baseKey}.page.regions.items`, { returnObjects: true });
  const regionItems = Array.isArray(regions) ? regions : [];

  const objectiveItems = t(`${baseKey}.page.objectives.items`, {
    returnObjects: true,
  });
  const objectives = Array.isArray(objectiveItems) ? objectiveItems : [];

  const visionItems = t(`${baseKey}.page.commitment.visionItems`, {
    returnObjects: true,
  });
  const vision = Array.isArray(visionItems) ? visionItems : [];

  const closingParas = t(`${baseKey}.page.commitment.closing`, {
    returnObjects: true,
  });
  const closing = Array.isArray(closingParas) ? closingParas : [];

  const introParas = t(`${baseKey}.page.intro`, {
    returnObjects: true,
    projectNo: project?.projectNo,
    universities: project?.universitiesCount,
    countries: project?.countriesCount,
  });
  const intro = Array.isArray(introParas) ? introParas : [];

  return (
    <>
      <Navbar />

      <Bredcom subtitle={t("projects.ka171.page.title")} />

      <div className="container mt-4 pt-40 project-detail">
        <div className="row">
          {/* Glavni tekst */}
          <div className="col-lg-8 col-md-7">
            <div className="content-container lower-content">
              {/* EU emblem + funding text */}
              <div className="project-logos mb-4">
                <img
                  src={project?.logos?.eu}
                  alt="European Union emblem"
                  className="project-logo-eu"
                />
                <span className="project-eu-text">
                  {t(`${baseKey}.page.euFunding`)}
                </span>
              </div>

              {/* Project logo + partner + Erasmus */}
              <div className="project-logos mb-4">
                <img
                  src={project?.logos?.main}
                  alt="Erasmus+ KA171 project logo"
                  className="project-logo-main"
                />
                <img
                  src={project?.logos?.partner}
                  alt="International Business School (IBS) Sofia logo"
                  className="project-logo-partner"
                />
                <img
                  src={project?.logos?.erasmus}
                  alt="Erasmus+ logo"
                  className="project-logo-partner"
                />
              </div>

              <h2 className="section-title">{t(`${baseKey}.page.title`)}</h2>

              <div className="textjustify">
                <p>
                  <strong>
                    {t(`${baseKey}.page.meta.projectNo`, {
                      projectNo: project?.projectNo,
                    })}
                  </strong>
                </p>
                <p>
                  <strong>{t(`${baseKey}.page.meta.keyAction`)}</strong>
                </p>
                <p>
                  <strong>
                    {t(`${baseKey}.page.meta.duration`, {
                      startDate: project?.startDate,
                      endDate: project?.endDate,
                    })}
                  </strong>
                </p>

                {intro.map((p, idx) => (
                  <p key={idx}>{p}</p>
                ))}

                <div className="values-section-ka171">
                  <p>{t(`${baseKey}.page.regions.intro`)}</p>
                  <ul>
                    {regionItems.map((item, idx) => (
                      <li key={idx}>
                        <strong>{item.label}:</strong> {item.value}
                      </li>
                    ))}
                  </ul>
                </div>

                <p>{t(`${baseKey}.page.regions.outro`)}</p>

                <h3>{t(`${baseKey}.page.objectives.title`)}</h3>
                <div className="values-section-ka171">
                  <p>{t(`${baseKey}.page.objectives.intro`)}</p>
                  <ul>
                    {objectives.map((item, idx) => (
                      <li key={idx}>
                        <strong>{item.strong}</strong>, {item.text}
                      </li>
                    ))}
                  </ul>
                </div>

                <p>{t(`${baseKey}.page.objectives.outro`)}</p>

                <h3>{t(`${baseKey}.page.commitment.title`)}</h3>
                <p>{t(`${baseKey}.page.commitment.intro`)}</p>

                <div className="values-section-ka171">
                  <p>{t(`${baseKey}.page.commitment.visionIntro`)}</p>
                  <ul>
                    {vision.map((v, idx) => (
                      <li key={idx}>{v}</li>
                    ))}
                  </ul>
                </div>

                {closing.map((p, idx) => (
                  <p key={idx}>{p}</p>
                ))}
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="col-lg-4 col-md-5">
            <div className="info-column">
              <div className="inner-column3">
                <h3>{t(`${baseKey}.sidebar.title`)}</h3>

                <ul className="project-info">
                  <li>
                    <span className="icon">
                      <i className="fas fa-project-diagram" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.projectTitleLabel`)}</h5>
                      <p>
                        {t(`${baseKey}.page.title`)}
                        <br />
                        <strong>
                          {t(`${baseKey}.sidebar.projectNoStrongLabel`)}
                        </strong>{" "}
                        {project?.projectNo}
                      </p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-calendar-alt" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.durationLabel`)}</h5>
                      <p>
                        {t(`${baseKey}.sidebar.durationValue`, {
                          months: project?.durationMonths,
                          startDate: project?.startDate,
                          endDate: project?.endDate,
                        })}
                      </p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-university" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.coordinatorLabel`)}</h5>
                      <p>{t(`${baseKey}.card.coordinator`)}</p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-users" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.consortiumLabel`)}</h5>
                      <p>
                        {t(`${baseKey}.sidebar.consortiumValue`, {
                          universities: project?.universitiesCount,
                          countries: project?.countriesCount,
                        })}
                      </p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-tasks" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.keyActivitiesLabel`)}</h5>
                      <p>{t(`${baseKey}.sidebar.keyActivitiesValue`)}</p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-hashtag" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.hashtagLabel`)}</h5>
                      <p>
                        <a
                          href={project?.hashtagLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          #ErasmusPlusKA171
                        </a>
                      </p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fab fa-facebook-f" />
                    </span>
                    <div>
                      <h5>Facebook</h5>
                      <p>
                        <a
                          href={project?.social?.facebook}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          @IBSEDU
                        </a>
                      </p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fab fa-instagram" />
                    </span>
                    <div>
                      <h5>Instagram</h5>
                      <p>
                        <a
                          href={project?.social?.instagram}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          @ibsedu
                        </a>
                      </p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fab fa-linkedin-in" />
                    </span>
                    <div>
                      <h5>LinkedIn</h5>
                      <p>
                        <a
                          href={project?.social?.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          International Business School (IBS)
                        </a>
                      </p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fab fa-tiktok" />
                    </span>
                    <div>
                      <h5>Tiktok</h5>
                      <p>
                        <a
                          href={project?.social?.tiktok}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          IBS Bulgaria
                        </a>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default ProjectSingleKA171;
